import { render, staticRenderFns } from "./resource-card.vue?vue&type=template&id=847eb04a&scoped=true&"
import script from "./resource-card.ts?vue&type=script&lang=ts&"
export * from "./resource-card.ts?vue&type=script&lang=ts&"
import style0 from "./resource-card.scss?vue&type=style&index=0&id=847eb04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847eb04a",
  null
  
)

export default component.exports